import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {trigger, state, animate, transition, style,keyframes} from '@angular/animations';
import { EditPopup } from '../.././shared/edit-popup';
import { SharedService } from '../.././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../.././shared/base.component';
@Component({
    selector: 'password-complexity',
    templateUrl: 'password-complexity.component.html',
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(600, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ]
})
export class PasswordComplexityComponent extends BaseComponent implements OnInit, EditPopup {
    @Output() done = new EventEmitter();
    @Input() passwordcomplexity: string[];

    constructor(protected sharedService: SharedService, protected translate: TranslateService) {
        super(sharedService, translate);
    }
    ngOnInit() {

    }
    close(success?: boolean) {
        this.done.emit(null);
    }
}